import { Component, Input } from '@angular/core';
import { MunilyCardContent } from './card.types';

@Component({
  selector: 'common-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent {
  @Input() title: MunilyCardContent['title'] = '';
  @Input() subtitle: MunilyCardContent['subtitle'] = '';
}
